
<template lang="pug">

  div.eui-common_linear_progress(role="progressbar", :loading="loading")
    .eui-common_linear_progress_bar.eui-common_linear_progress_bar1
    .eui-common_linear_progress_bar.eui-common_linear_progress_bar2

</template>


<script>

export default {
  name: 'linear-progress',
  props: {
    loading: { type: Boolean },
  },
};

</script>

<style lang="scss">

  .eui-common_linear_progress {
    height: 4px;
    position: relative;
    overflow: hidden;

    &_bar {
      top: 0;
      left: 0;
      width: 100%;
      bottom: 0;
      position: absolute;
      transition: transform 0.2s linear;
      transform-origin: left;
      background-color: #ccc;
    }

    &_bar1 {
      width: auto;
      animation: mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      will-change: left, right;
    }
    &_bar2 {
      width: auto;
      animation: mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
      will-change: left, right;
      animation-delay: 1.15s;
    }
  }

  @keyframes mui-indeterminate1 {
    0% {
      left: -35%;
      right: 100%;
    }
    60% {
      left: 100%;
      right: -90%;
    }
    100% {
      left: 100%;
      right: -90%;
    }
  }

  @keyframes mui-indeterminate2 {
    0% {
      left: -200%;
      right: 100%;
    }
    60% {
      left: 107%;
      right: -8%;
    }
    100% {
      left: 107%;
      right: -8%;
    }
  }


</style>
